export default {
  development: 'https://localhost.termly.io',
  production: 'https://app.termly.io',
  staging: 'https://app.termlystaging.io',
  test: 'http://testing.termlystaging.io',
}
